import { render, staticRenderFns } from "./courseSettings.vue?vue&type=template&id=63d3e73c&scoped=true"
import script from "./courseSettings.vue?vue&type=script&lang=js"
export * from "./courseSettings.vue?vue&type=script&lang=js"
import style0 from "./courseSettings.vue?vue&type=style&index=0&id=63d3e73c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d3e73c",
  null
  
)

export default component.exports